<div class="relative flex flex-col">
    <!--- Text Block --->
    <div
        class="md:flex md:items-center"
        [ngClass]="!last ? 'border-r border-r-grey-150' : ''">
        <section
            class="flex flex-row p-8 pb-8"
            [ngClass]="{ 'md:pr-10': last, 'md:pl-10': first }">
            <div>
                <div class="pb-4 text-center text-xl font-bold md:text-left">
                    {{ reason?.title }}
                </div>
                <div class="text-center text-sm md:text-left">
                    {{ reason?.body }}
                </div>
            </div>
        </section>
    </div>
    <!--- Image Block --->
    <div
        class="flex justify-center px-8 md:relative"
        [ngClass]="{ 'md:pr-0': last, 'md:pl-0': first }">
        <div class="w-1/2 md:max-w-72">
            <div class="aspect-h-1 aspect-w-1">
                <app-lazy-asset [configuration]="imageConfiguration">
                </app-lazy-asset>
            </div>
        </div>
    </div>
</div>
